var render, staticRenderFns
import script from "./MyAPlayer.vue?vue&type=script&lang=js&"
export * from "./MyAPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccccaff",
  null
  
)

export default component.exports